/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer components {
  .link {
    display: inline;
    border-style: var(--tw-border-style);
    border-width: 0px;
    background-color: transparent;
    padding: calc(var(--spacing, 0.25rem) * 0);
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
    &[aria-disabled="true"] {
      cursor: default;
    }
  }
  .unstyled {
    cursor: pointer;
    color: inherit;
    text-decoration-line: none;
    &:hover {
      @media (hover: hover) {
        color: inherit;
      }
    }
    &:hover {
      @media (hover: hover) {
        text-decoration-line: none;
      }
    }
    &:focus-visible {
      color: inherit;
    }
    &:focus-visible {
      text-decoration-line: none;
    }
  }
  .primary {
    cursor: pointer;
    color: var(--color-primary-600);
    text-decoration-line: none;
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
    transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
    &:hover {
      @media (hover: hover) {
        color: inherit;
      }
    }
    &:focus-visible {
      color: var(--foundation-gray-800);
    }
    &[aria-disabled="true"] {
      color: var(--foundation-graphite-400);
    }
    &[aria-disabled="true"] {
      &:hover,	&:focus-visible {
        cursor: not-allowed;
      }
    }
    &[aria-disabled="true"] {
      &:hover,	&:focus-visible {
        color: var(--foundation-graphite-400);
      }
    }
  }
  .secondary {
    cursor: pointer;
    color: var(--foundation-gray-800);
    text-decoration-line: underline;
    &:hover {
      @media (hover: hover) {
        color: var(--foundation-gray-800);
      }
    }
    &:hover {
      @media (hover: hover) {
        text-decoration-line: none;
      }
    }
    &:focus-visible {
      color: var(--foundation-gray-800);
    }
    &:focus-visible {
      text-decoration-line: none;
    }
  }
  .tertiary {
    cursor: pointer;
    font-size: var(--text-13, 0.8125rem);
    --tw-font-weight: var(--font-weight-normal, 400);
    font-weight: var(--font-weight-normal, 400);
    color: var(--foundation-gray-800);
    text-decoration-line: underline;
    &:hover {
      @media (hover: hover) {
        color: var(--foundation-gray-800);
      }
    }
    &:hover {
      @media (hover: hover) {
        text-decoration-line: none;
      }
    }
    &:focus-visible {
      color: var(--foundation-gray-800);
    }
    &:focus-visible {
      text-decoration-line: none;
    }
  }
  .light {
    cursor: pointer;
    font-size: var(--text-13, 0.8125rem);
    --tw-font-weight: var(--font-weight-normal, 400);
    font-weight: var(--font-weight-normal, 400);
    color: var(--color-white, #ffffff);
    text-decoration-line: underline;
    &:hover {
      @media (hover: hover) {
        color: var(--color-white, #ffffff);
      }
    }
    &:hover {
      @media (hover: hover) {
        text-decoration-line: none;
      }
    }
    &:focus-visible {
      color: var(--color-white, #ffffff);
    }
    &:focus-visible {
      text-decoration-line: none;
    }
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
